import React from 'react';
import { Notifications } from 'components/Notifications/Notifications';
import { Routers } from 'services';
import styles from './Content.module.scss';

const { Main, MainWrapper } = styles;

export const Content = () => {
    return (
        <div className={Main}>
            <div className={MainWrapper}>
                <Routers />
            </div>
            <Notifications />
        </div>
    );
};
